import React, { useEffect, useState } from 'react';
import { Container, Typography } from '@mui/material';
import apiCall from '../../utils/apiUtils';
import CampaignList from '../../components/CampaignList';

const PurchasesPage: React.FC = () => {
  const [items, setItems] = useState<any[]>([]);

  useEffect(() => {
    apiCall('/ListPurchases', null, (res: any) => {
      const rows = Array.isArray(res) ? res : [];
      // Map to CampaignList expected shape
      const mapped = rows.map((r: any) => ({
        nSaleId: r.nSaleId,
        vTitle: r.vTitle,
        vSmlImg: r.vSmlImg,
        vDescription: r.vDescription,
        nValue: typeof r.nAmount === 'number' ? r.nAmount : (r.nOriginalAmt || 0),
        purchaseId: r.id,
        cardNum: r.vCardNum1
      }));
      setItems(mapped);
    }, 'GET');
  }, []);

  return (
    <Container maxWidth="lg">
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Purchased Cards
      </Typography>
      <Typography variant="subtitle1" align="center" gutterBottom>
        Your completed purchases are listed below.
      </Typography>
      <CampaignList campaigns={items} hideBuy />
    </Container>
  );
};

export default PurchasesPage;
